import { Component, inject, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { NotificationsService } from 's1m-angular-bootstrap-lib';

import { RecoveryBlocAction, RecoveryBlocEvent } from './models/recovery-bloc.model';
import { RecoveryBlocService } from './services/recovery-bloc.service';
import { matchFields, S1mAngularCommonLibModule } from 's1m-angular-common-lib';
import { ButtonComponent } from 'src/app/shared/button/button.component';
import { NgIf, NgStyle } from '@angular/common';

@Component({
  selector: 'app-recovery',
  templateUrl: './recovery.component.html',
  styleUrls: ['./recovery.component.scss'],
  providers: [RecoveryBlocService],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    TranslateModule,
    NgStyle,
    NgIf,
    S1mAngularCommonLibModule,
  ],
})
export class RecoveryComponent implements OnDestroy {
  fb = inject(FormBuilder);
  router = inject(Router);
  route = inject(ActivatedRoute);
  notificationsService = inject(NotificationsService);
  translateService = inject(TranslateService);
  bloc = inject(RecoveryBlocService);

  loading = false;
  id: string | null = this.route.snapshot.queryParamMap.get('id');
  showNewPassword = false;
  showConfirmNewPassword = false;
  blocActionsSubscription!: Subscription;

  private PASSWORD_PATTERN = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])((?=.*\W)|(?=.*_))^[^ ]+$/;

  form = this.fb.group(
    {
      password: new FormControl<string>('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(this.PASSWORD_PATTERN),
          Validators.maxLength(50),
        ],
      }),
      confirmPassword: new FormControl<string>('',{ nonNullable: true, validators: Validators.required }),
    },
    {
      validators: [matchFields('confirmPassword', 'password')],
    },
  );


  constructor() {
    this.listenToBlocActions();
    this.id = this.route.snapshot.queryParamMap.get('id');
    if (!this.id) {
      this.backToLogin();
    }
  }

  listenToBlocActions() {
    this.blocActionsSubscription = this.bloc.actions$.subscribe((action) => {
      switch (action.name) {
        case RecoveryBlocAction.passwordChanged:
          this.onResetPasswordSuccess();
          break;
      }
    });
  }

  onResetPasswordSuccess() {
    this.notificationsService.addSuccess(this.translateService.instant('login.passwordChangedMessage'));
    this.backToLogin();
  }

  onShowPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  onShowConfirmNewPassword() {
    this.showConfirmNewPassword = !this.showConfirmNewPassword;
  }

  resetPassword() {
    this.bloc.addEvent(RecoveryBlocEvent.changePassword, { id: this.id!, ...this.form.getRawValue() });
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }

  ngOnDestroy() {
    this.blocActionsSubscription.unsubscribe();
  }
}
